import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import FooterSection from './FooterSection';
import './BooksPage.css';

export default function BooksPage() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCourse, setSelectedCourse] = useState('All');
  const [selectedTerm, setSelectedTerm] = useState('All');

  // Fetch books from Express API
  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/books/books-library');
        const result = await response.json();

        if (result.success && Array.isArray(result.data)) {
          setBooks(result.data);
        }
      } catch (error) {
        console.error('Error loading library books:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  // Extract unique courses for dropdown filter
  const courseOptions = [
    'All',
    ...Array.from(new Set(books.map((b) => b.course_name).filter(Boolean)))
  ];

  // Extract unique term/semester labels for dropdown filter
  const termOptions = [
    'All',
    ...Array.from(new Set(books.map((b) => b.term_label).filter(Boolean)))
  ];

  // Filtering Logic based on Search & Dropdowns
  const filteredBooks = books.filter((book) => {
    const query = searchTerm.toLowerCase();
    const matchesSearch =
      (book.book_title && book.book_title.toLowerCase().includes(query)) ||
      (book.paper_title && book.paper_title.toLowerCase().includes(query)) ||
      (book.author_name && book.author_name.toLowerCase().includes(query)) ||
      (book.course_name && book.course_name.toLowerCase().includes(query));

    const matchesCourse =
      selectedCourse === 'All' || book.course_name === selectedCourse;

    const matchesTerm =
      selectedTerm === 'All' || book.term_label === selectedTerm;

    return matchesSearch && matchesCourse && matchesTerm;
  });

  return (
    <>
      <Navbar />
      <div className="books-page-wrapper">
        
        {/* 1. Luxurious Hero Banner */}
        <section className="books-hero-banner">
          <div className="inner-banner-container">
            <nav className="breadcrumb-nav">
              <Link to="/" className="breadcrumb-link">Home</Link> / <span>E-Library</span>
            </nav>
            <span className="hero-gold-badge">ACADEMIC KNOWLEDGE REPOSITORY</span>
            <h1>Digital Course Library &amp; Books</h1>
            <p>Access prescribed textbooks, reference materials, and semester study guides online.</p>
          </div>
        </section>

        {/* 2. Control Bar: Search & Dropdown Filters */}
      {/* 2. Control Bar: Search & Dropdown Filters */}
<section className="books-control-section">
  <div className="books-container">
    
    <div className="filter-card-wrapper">
      
      {/* Search Field (Left Aligned) */}
      <div className="search-input-box">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          placeholder="Search by book title, author, or paper..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Dropdown Filters (Pushed to the Right End) */}
      <div className="filters-right-group">
        
        {/* Course Filter Dropdown */}
        <div className="select-dropdown-box">
          <label className="select-label">Filter Course:</label>
          <select
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            className="filter-select"
          >
            {courseOptions.map((course, idx) => (
              <option key={idx} value={course}>
                {course}
              </option>
            ))}
          </select>
        </div>

        {/* Term/Semester Filter Dropdown */}
        <div className="select-dropdown-box">
          <label className="select-label">Semester/Term:</label>
          <select
            value={selectedTerm}
            onChange={(e) => setSelectedTerm(e.target.value)}
            className="filter-select"
          >
            {termOptions.map((term, idx) => (
              <option key={idx} value={term}>
                {term}
              </option>
            ))}
          </select>
        </div>

      </div>

    </div>

    {/* Results Metadata Bar */}
    <div className="results-count-bar">
      <span>{loading ? 'Loading library records...' : `${filteredBooks.length} books found`}</span>
      {(selectedCourse !== 'All' || selectedTerm !== 'All' || searchTerm) && (
        <button
          className="reset-filter-btn"
          onClick={() => {
            setSearchTerm('');
            setSelectedCourse('All');
            setSelectedTerm('All');
          }}
        >
          Reset Filters ✕
        </button>
      )}
    </div>

  </div>
</section>

        {/* 3. Books Cards Grid Section */}
        <section className="books-grid-section">
          <div className="books-container">
            
            {loading ? (
              <div className="no-books-card">
                <h3>Loading Digital Library...</h3>
                <p>Please wait while we retrieve course literature.</p>
              </div>
            ) : filteredBooks.length > 0 ? (
              <div className="books-cards-grid">
                {filteredBooks.map((book) => {
                  const hasPdf = Boolean(book.book_file_url);

                  return (
                    <div key={book.id} className="book-item-card">
                      
                      {/* Top Accent Ribbon */}
                      <div className="card-top-accent"></div>

                      <div className="book-card-body">
                        
                        {/* Course & Term Badges Header */}
                        <div className="badge-header-row">
                          <span className="course-code-pill">
                            {book.course_code ? `[${book.course_code}]` : 'COURSE'} {book.course_name}
                          </span>
                          <span className="term-badge">{book.term_label || 'General'}</span>
                        </div>

                        {/* Paper Title Subhead */}
                        <div className="paper-title-tag">
                          📖 <span>Paper:</span> {book.paper_title || 'N/A'}
                        </div>

                        {/* Main Book Title */}
                        <h3 className="book-title-heading">{book.book_title}</h3>

                        {/* Author & Publisher Specifications */}
                        <div className="book-meta-details">
                          <div className="meta-row">
                            <span className="meta-label">Author:</span>
                            <span className="meta-value font-bold">{book.author_name || 'Standard Reference'}</span>
                          </div>
                          <div className="meta-row">
                            <span className="meta-label">Publisher:</span>
                            <span className="meta-value">{book.publisher_name || 'Academic Press'}</span>
                          </div>
                        </div>

                        {/* Download / View Button */}
                        <div className="card-action-footer">
                          {hasPdf ? (
                            <a
                              href={book.book_file_url}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn-download-pdf"
                            >
                              <span className="dl-icon">📥</span> Download E-Book (PDF)
                            </a>
                          ) : (
                            <button className="btn-disabled-pdf" disabled>
                              🔒 Library Copy Only
                            </button>
                          )}
                        </div>

                      </div>

                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="no-books-card">
                <h3>No books match your filter criteria.</h3>
                <p>Try searching for a different keyword or selecting "All" in the course dropdown.</p>
              </div>
            )}

          </div>
        </section>

      </div>
      <FooterSection />
    </>
  );
}